import React from 'react'
import PropTypes from 'prop-types'
import { PortalContext } from './PortalContext'
import PortalRegistry from './PortalRegistry'
import PortalDest from './PortalDest'

class PortalProvider extends React.PureComponent {
  static propTypes = {
    channels: PropTypes.array
  }

  static defaultProps = {
    channels: []
  }

  constructor (props) {
    super(props)
    this.registry = new PortalRegistry()
  }

  render () {
    const { channels, children } = this.props
    return (
      <PortalContext.Provider value={this.registry}>
        {children}
        {channels.map((channel) => (<PortalDest key={channel} channel={channel} />))}
      </PortalContext.Provider>
    )
  }
}

export default PortalProvider
